import { Reducer } from '@reduxjs/toolkit'

import {
  TActionTypes,
  GET_ACTIVITY_LOADING,
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_FAILURE,
  GET_ACTIVITY_CATEGORIES_LOADING,
  GET_ACTIVITY_CATEGORIES_SUCCESS,
  GET_ACTIVITY_CATEGORIES_FAILURE,
  GET_DEPARTMENTS_LOADING,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_FAILURE,
  GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE,
  GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS,
  GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING,
} from '../interface/actionTypes'
import { IActivityState } from '../interface/IActivityState'

const initialState: IActivityState = {
  activity: {
    list: undefined,
    loading: false,
    error: '',
  },
  activityCategories: {
    list: undefined,
    loading: false,
    error: '',
  },
  departments: {
    list: undefined,
    loading: false,
    error: '',
  },
  activityWithCode: {
    list: undefined,
    loading: false,
    error: '',
  },
}

export const activityReducer: Reducer<IActivityState, TActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_ACTIVITY_LOADING:
      return {
        ...state,
        activity: {
          ...state.activity,
          loading: true,
        },
      }
    case GET_ACTIVITY_SUCCESS:
      return {
        ...state,
        activity: {
          ...state.activity,
          loading: false,
          list: action.payload.activity,
        },
      }
    case GET_ACTIVITY_FAILURE:
      return {
        ...state,
        activity: {
          ...state.activity,
          loading: false,
          error: action.payload.error,
        },
      }
    case GET_ACTIVITY_WITH_TREATMENT_CODE_LOADING:
      return {
        ...state,
        activityWithCode: {
          ...state.activityWithCode,
          loading: true,
        },
      }
    case GET_ACTIVITY_WITH_TREATMENT_CODE_SUCCESS:
      return {
        ...state,
        activityWithCode: {
          ...state.activityWithCode,
          loading: false,
          list: action.payload.activityWithCode,
        },
      }
    case GET_ACTIVITY_WITH_TREATMENT_CODE_FAILURE:
      return {
        ...state,
        activityWithCode: {
          ...state.activityWithCode,
          loading: false,
          error: action.payload.error,
        },
      }
    case GET_ACTIVITY_CATEGORIES_LOADING:
      return {
        ...state,
        activityCategories: {
          ...state.activityCategories,
          loading: true,
        },
      }
    case GET_ACTIVITY_CATEGORIES_SUCCESS:
      return {
        ...state,
        activityCategories: {
          ...state.activityCategories,
          loading: false,
          list: action.payload.activityCategories,
        },
      }
    case GET_ACTIVITY_CATEGORIES_FAILURE:
      return {
        ...state,
        activityCategories: {
          ...state.activityCategories,
          loading: false,
          error: action.payload.error,
        },
      }
    case GET_DEPARTMENTS_LOADING:
      return {
        ...state,
        departments: {
          ...state.departments,
          loading: true,
        },
      }
    case GET_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: {
          ...state.departments,
          loading: false,
          list: action.payload.departments,
        },
      }
    case GET_DEPARTMENTS_FAILURE:
      return {
        ...state,
        departments: {
          ...state.departments,
          loading: false,
          error: action.payload.error,
        },
      }
    default:
      return state
  }
}
